var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteStarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5682_2359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6243 10.8334C6.56478 10.6026 6.44453 10.3921 6.27605 10.2236C6.10757 10.0551 5.89702 9.93488 5.6663 9.87536L1.5763 8.82069C1.50652 8.80088 1.44511 8.75886 1.40138 8.70099C1.35765 8.64312 1.33398 8.57256 1.33398 8.50002C1.33398 8.42749 1.35765 8.35693 1.40138 8.29906C1.44511 8.24119 1.50652 8.19916 1.5763 8.17936L5.6663 7.12402C5.89693 7.06456 6.10743 6.94441 6.2759 6.77605C6.44438 6.60769 6.56468 6.39728 6.6243 6.16669L7.67897 2.07669C7.69857 2.00664 7.74056 1.94492 7.79851 1.90095C7.85647 1.85699 7.92722 1.83319 7.99997 1.83319C8.07271 1.83319 8.14346 1.85699 8.20142 1.90095C8.25938 1.94492 8.30136 2.00664 8.32097 2.07669L9.37497 6.16669C9.43449 6.3974 9.55474 6.60795 9.72322 6.77644C9.8917 6.94492 10.1023 7.06517 10.333 7.12469L14.423 8.17869C14.4933 8.19809 14.5553 8.24003 14.5995 8.29807C14.6437 8.35612 14.6677 8.42706 14.6677 8.50002C14.6677 8.57298 14.6437 8.64393 14.5995 8.70197C14.5553 8.76002 14.4933 8.80196 14.423 8.82136L10.333 9.87536C10.1023 9.93488 9.8917 10.0551 9.72322 10.2236C9.55474 10.3921 9.43449 10.6026 9.37497 10.8334L8.3203 14.9234C8.3007 14.9934 8.25871 15.0551 8.20075 15.0991C8.1428 15.1431 8.07205 15.1669 7.9993 15.1669C7.92656 15.1669 7.85581 15.1431 7.79785 15.0991C7.73989 15.0551 7.69791 14.9934 7.6783 14.9234L6.6243 10.8334Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 2.5V5.16667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.83331H12",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 11.8333V13.1666",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12.5H2",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5682_2359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStarIcon);
export default __webpack_public_path__ + "static/media/white-star-icon.08c236dc5e119adf969ee2abbcfcdda1.svg";
export { ForwardRef as ReactComponent };